export default __webpack_public_path__ + "static/media/SlashDice.5644bec6.png";